"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _class, _descriptor, _descriptor2, _temp;

var EventScheduleDiscussionHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventScheduleDiscussionHeader, _Component);

  function EventScheduleDiscussionHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, EventScheduleDiscussionHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(EventScheduleDiscussionHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "header", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(EventScheduleDiscussionHeader, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "notification-discussion-header"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "message"
      }), _react.default.createElement("h3", null, this.header.catalogItem.title), _react.default.createElement("h4", null, this.header.activity.title));
    }
  }]);
  return EventScheduleDiscussionHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "header", [prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = EventScheduleDiscussionHeader;